import {
  StoresSDK,
  type Store,
  type StoresSDKConfig,
  type StoresErrorResponse,
  type StoreListParams,
  type StoreListResponse,
  type StoreClustersParams,
  type StoreClustersResponse
} from '@dcxwam/stores-sdk'
import MockData, {
  MockStoreListData,
  MockStoreClustersData
} from '../../components/organisms/StoreDetails/api-mock-data.mock'

// Re-export types and enums from SDK for use in components (separation layer)
export type {
  Store,
  StoresSDKConfig,
  StoresErrorResponse,
  StoreListParams,
  StoreListResponse,
  StoreClustersParams,
  StoreClustersResponse,
  GeoLocation,
  OpeningHour,
  Address,
  StoreCluster
} from '@dcxwam/stores-sdk'

export { StoresSDK, SortField, SortOrder } from '@dcxwam/stores-sdk'

export const createStoresSDK = (config: StoresSDKConfig) => {
  return new StoresSDK(config)
}

export const isStore = (
  data: Store | StoresErrorResponse | null | undefined
): data is Store => {
  return !!(data as Store)?.storeId
}

export const getStore = async (
  sdk: StoresSDK,
  storeId: string,
  isMock?: boolean
): Promise<Store | StoresErrorResponse | null> => {
  if (isMock) {
    return {
      ...MockData,
      storeId
    }
  }
  return sdk.getStore(storeId)
}

export const getStoreList = async (
  sdk: StoresSDK,
  params: StoreListParams = {},
  isMock?: boolean
): Promise<StoreListResponse | StoresErrorResponse | null> => {
  if (isMock) {
    return MockStoreListData
  }
  return sdk.getStoreList(params)
}

export const getStoreClusters = async (
  sdk: StoresSDK,
  params: StoreClustersParams,
  isMock?: boolean
): Promise<StoreClustersResponse | StoresErrorResponse | null> => {
  if (isMock) {
    return MockStoreClustersData
  }
  return sdk.getStoreClusters(params)
}

export const getStores = async (
  sdk: StoresSDK,
  storeIds: string[],
  isMock?: boolean
): Promise<Store[] | null> => {
  if (isMock) {
    return [MockData]
  }
  return sdk.getStores(storeIds)
}
